import { type VoidFunctionComponent } from 'react';

import SnippetsContainer from '..';
import { useParams } from '../../../../contexts/RouterContext';
import { getProjectBaseURLFromParams, nuc } from '../../../../utils';
import SubnavCountBadge from '../../../generic/Subnav/SubnavCountBadge';
import SidebarNavLayout from '../../../layouts/SidebarNavLayout';
import useComparedSnippetCounts from '../hooks/useComparedSnippetCounts';
import type { SnippetStatus } from '../../../../../shared/snippets';
import type { SnippetsRouteParams } from '../../../../hooks/api/snippets/shared';

import styles from './Layout.module.less';

type Props = {
  olderRevisionLocator: string;
};

const Layout: VoidFunctionComponent<Props> = ({ olderRevisionLocator }) => {
  const routeParams = useParams<SnippetsRouteParams>();
  const userRevisionLocator = `${routeParams.project_id}$${routeParams.revision_id}`;

  const comparedSnippetCounts = useComparedSnippetCounts({ userRevisionLocator, olderRevisionLocator });

  const baseProjectURL = getProjectBaseURLFromParams(routeParams);
  const compareURL = `${baseProjectURL}/browse/snippets/compare`;

  const getNavItemURL = (status: SnippetStatus) => {
    return `${compareURL}/${status}?olderRevisionLocator=${nuc(olderRevisionLocator)}`;
  };

  return (
    <SidebarNavLayout>
      <SidebarNavLayout.Nav>
        <SidebarNavLayout.NavHeading>
          Status
        </SidebarNavLayout.NavHeading>
        <SidebarNavLayout.NavItem
          to={getNavItemURL('new')}
          isActive={routeParams.status === 'new'}
        >
          <div className={styles.sidebarNavItem}>
            New
            <SubnavCountBadge
              count={comparedSnippetCounts.new.count}
              isLoading={comparedSnippetCounts.new.isLoading}
            />
          </div>
        </SidebarNavLayout.NavItem>
        <SidebarNavLayout.NavItem
          to={getNavItemURL('removed')}
          isActive={routeParams.status === 'removed'}
        >
          <div className={styles.sidebarNavItem}>
            Removed
            <SubnavCountBadge
              count={comparedSnippetCounts.removed.count}
              isLoading={comparedSnippetCounts.removed.isLoading}
            />
          </div>
        </SidebarNavLayout.NavItem>
        <SidebarNavLayout.NavItem
          to={getNavItemURL('unchanged')}
          isActive={routeParams.status === 'unchanged'}
        >
          <div className={styles.sidebarNavItem}>
            Unchanged
            <SubnavCountBadge
              count={comparedSnippetCounts.unchanged.count}
              isLoading={comparedSnippetCounts.unchanged.isLoading}
            />
          </div>
        </SidebarNavLayout.NavItem>
      </SidebarNavLayout.Nav>
      <SidebarNavLayout.Content>
        <div>
          <SnippetsContainer />
        </div>
      </SidebarNavLayout.Content>
    </SidebarNavLayout>
  );
};

export default Layout;
